/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_EnabledInputs */

const en_users_enabled = /** @type {(inputs: Users_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

const pt_br2_users_enabled = /** @type {(inputs: Users_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitado`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Users_EnabledInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_enabled = /** @type {((inputs?: Users_EnabledInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_EnabledInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_enabled(inputs)
	return pt_br2_users_enabled(inputs)
});